var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block block--header",class:{'block--seamless' : _vm.seamless},attrs:{"id":_vm.block.uid}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.block.header)}}),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.block.subheader)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5174e238","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/BlockHeader.vue
// module id = null
// module chunks = 